import { useState } from "react";
import { latestAddress } from "@/mocks/articles";

export default function LatestAddressSection() {
  const [copiedIndex, setCopiedIndex] = useState<number | null>(null);

  const handleCopy = async (text: string, index: number) => {
    try {
      await navigator.clipboard.writeText(text);
      setCopiedIndex(index);
      setTimeout(() => setCopiedIndex(null), 2000);
    } catch {
      // Fallback
      const textArea = document.createElement("textarea");
      textArea.value = text;
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand("copy");
      document.body.removeChild(textArea);
      setCopiedIndex(index);
      setTimeout(() => setCopiedIndex(null), 2000);
    }
  };

  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950">
            <i className="ri-links-line text-primary-500 mr-2"></i>
            最新可用地址
          </h2>
          <p className="mt-3 text-foreground-600 max-w-xl mx-auto text-sm">
            以下地址均经过人工验证，确保安全可用。如遇访问问题，请刷新本页获取更新。
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {latestAddress.slice(0, 6).map((addr, index) => (
            <div
              key={addr.id}
              className="bg-background-50 border border-background-200/70 rounded-xl p-5 hover:border-primary-200 transition-all group"
            >
              <div className="flex items-start justify-between mb-3">
                <span className="inline-flex items-center gap-1.5 px-2.5 py-1 bg-accent-100 text-accent-700 rounded-full text-xs font-semibold">
                  <i className="ri-check-line"></i>
                  已验证
                </span>
                <span className="text-xs text-foreground-400">{addr.date}</span>
              </div>
              <h3 className="font-semibold text-foreground-950 text-sm mb-2 line-clamp-2">
                {addr.title}
              </h3>
              <p className="text-xs text-foreground-500 mb-4 line-clamp-2">
                {addr.excerpt}
              </p>
              <div className="flex items-center gap-2">
                <a
                  href={`/article/${addr.slug}`}
                  className="flex-1 text-center py-2 rounded-lg bg-background-100 hover:bg-background-200 text-foreground-700 text-xs font-medium whitespace-nowrap transition-colors cursor-pointer"
                >
                  查看详情
                </a>
                <button
                  onClick={() => handleCopy(addr.title, index)}
                  className={`flex items-center gap-1.5 px-4 py-2 rounded-lg text-xs font-medium whitespace-nowrap transition-all cursor-pointer ${
                    copiedIndex === index
                      ? "bg-accent-500 text-white"
                      : "bg-primary-500 hover:bg-primary-600 text-white"
                  }`}
                >
                  <i className={`ri-${copiedIndex === index ? "check" : "file-copy"}-line`}></i>
                  {copiedIndex === index ? "已复制" : "复制地址"}
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}